module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/mastercard-661750da4852c10c94ecca60f76e24ba.svg";